import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";

const PastPF2025 = () => {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Porchfest 2025</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div>
                            Winchester Porchfest 2025 was held on Saturday June 14. Here are some
                            of the moments from that day.
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div className="ratio ratio-16x9">
                            <iframe src="https://www.youtube.com/embed/8To8JWBddK0?si=BYhltfYB2rYJTEZ3"
                                    title="Porchfest 2025 Highlights"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen/>
                        </div>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <div className="ratio ratio-16x9">
                            <iframe src="https://www.youtube.com/embed/XNWsSoEr8zY?si=cpoCBBcHaeEj5uSd"
                                    title="Shukulele at Porchfest 2025"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen/>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PastPF2025;
